import React from 'react'
import { Button } from '@mantine/core'

import { StepperModalContent, useStepperContext } from '@/components'
import { CHAIN_INFO_LIST, DEX_CONFIG, DEX_INFO_LIST } from '@/config'
import { AnalyticsTracker } from '@/page-components/shared'
import { useSelectedDenom } from '../../../contexts/denom'

const WithdrawStTokenToDexStepTwo: React.FC = () => {
  // We'll intentionally use `forceClose` instead of `close` because technically this
  // flow will never be "complete" (the previous step doesn't call the `complete` method)
  const { forceClose } = useStepperContext()

  const [denom] = useSelectedDenom()

  const dexConfig = DEX_CONFIG[denom]

  // Making sure this doesn't crash on the off chance that we're here despite dexConfig not existing.
  if (dexConfig == null) {
    return null
  }

  const dexInfo = DEX_INFO_LIST[dexConfig.type]

  const poolUrl = dexInfo.poolUrl(dexConfig.poolId)

  const chainInfo = CHAIN_INFO_LIST[dexInfo.coinDenom]

  return (
    <>
      <StepperModalContent
        title={`Add your tokens to the pool`}
        description={`Your st${denom} has been transferred to ${chainInfo.chainName}. You can now provide liquidity or trade on ${dexInfo.name}. Remember to bond your shares to earn rewards, if you provide liquidity.`}
        actions={
          <>
            <Button variant="outline" color="dark" onClick={forceClose}>
              Exit
            </Button>

            <Button component="a" href={poolUrl} target="_blank">
              Go to {dexInfo.name}
            </Button>
          </>
        }
      />

      <AnalyticsTracker eventName="withdraw_st_token_to_dex_complete" />
    </>
  )
}

export { WithdrawStTokenToDexStepTwo }
